<template>
  <action-person-template :action="action" column="person" grid="person" title="Passeur"/>
</template>

<script>
import ActionPersonTemplate from './ActionPersonTemplate'

export default {
  name: 'SportFootballMatchActionPersonPlayerPasser',
  props: {
    action: Object
  },
  components: { ActionPersonTemplate }
}
</script>
